import VisibilityIcon from "@mui/icons-material/Visibility";
import {
	Box,
	IconButton,
	TableCell,
	TableRow,
	Tooltip,
	Typography,
	useTheme,
} from "@mui/material";

import { Link } from "react-router-dom";
import { imgUrl } from "src/Helpers/utils/constants";
import { getStatusLabelTraineeStatus } from "src/Utils/Combined";

const TraineeTableRow = ({ allMembers }: any) => {
	const theme = useTheme();
	return (
		<>
			<TableRow hover>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{allMembers.user_training_trainee_id}
					</Typography>
				</TableCell>
				<TableCell>
					<Box sx={{ display: "flex" }}>
						<img
							width={30}
							height={30}
							style={{
								borderRadius: "50%",
								marginRight: "10px",
							}}
							src={
								allMembers.user_training_trainee_photo
									? `${imgUrl}/training_trainee_files/${allMembers.user_training_trainee_photo}`
									: "/static/images/avatars/avatar2.png"
							}
							alt=""
						/>
						<Link
							to={`/courses/trainee/${allMembers.user_training_trainee_id.toString()}`}
						>
							<Typography
								variant="body1"
								color="text.primary"
								gutterBottom
								noWrap
							>
								{allMembers.user_training_trainee_name}
							</Typography>
						</Link>
					</Box>
				</TableCell>

				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{allMembers.user_training_trainee_email}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{getStatusLabelTraineeStatus(
							allMembers.user_training_trainee_account_status
						)}
					</Typography>
				</TableCell>
				<TableCell>
					<Link
						to={`/courses/trainee/${allMembers.user_training_trainee_id.toString()}`}
					>
						<Tooltip title="View" arrow>
							<IconButton
								sx={{
									"&:hover": {
										background:
											theme.colors.primary.lighter,
									},
									color: theme.palette.primary.main,
								}}
								color="inherit"
								size="small"
							>
								<VisibilityIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Link>
				</TableCell>
			</TableRow>
		</>
	);
};

export default TraineeTableRow;
